// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-sidebar {
  height: 100%;
  width: 100%;
  max-width: calc(100% - 1px);
  display: flex;
  flex-direction: column;
  background: white;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  overflow: hidden;
}

.right-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.right-sidebar-title {
  font-family: Roboto, sans-serif;
  font-size: 18px;
  line-height: 16px;
  color: black;
  margin: 0;
  font-weight: 400;
}

.right-sidebar-close {
  background: #666;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: white;
  padding: 0 0 2px 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.right-sidebar-close:hover {
  background-color: #555;
  color: white;
}

.right-sidebar-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/RightSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".right-sidebar {\n  height: 100%;\n  width: 100%;\n  max-width: calc(100% - 1px);\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-left: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  overflow: hidden;\n}\n\n.right-sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n.right-sidebar-title {\n  font-family: Roboto, sans-serif;\n  font-size: 18px;\n  line-height: 16px;\n  color: black;\n  margin: 0;\n  font-weight: 400;\n}\n\n.right-sidebar-close {\n  background: #666;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: white;\n  padding: 0 0 2px 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.right-sidebar-close:hover {\n  background-color: #555;\n  color: white;\n}\n\n.right-sidebar-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
